// extracted by mini-css-extract-plugin
var _1 = "PostDetailPreviewHeader-module__controlBarContainer--QMbT7";
var _2 = "PostDetailPreviewHeader-module__headerBar--hrs25";
var _3 = "PostDetailPreviewHeader-module__topicBarContainer--BrFXO";
var _4 = "PostDetailPreviewHeader-module__topicList--nTIOS";
export { _1 as "controlBarContainer", _2 as "headerBar", _3 as "topicBarContainer", _4 as "topicList" }
